import { render, staticRenderFns } from "./mineData.vue?vue&type=template&id=21ac0dfe&scoped=true"
import script from "./mineData.vue?vue&type=script&lang=js"
export * from "./mineData.vue?vue&type=script&lang=js"
import style0 from "./mineData.vue?vue&type=style&index=0&id=21ac0dfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac0dfe",
  null
  
)

export default component.exports